import emailjs from '@emailjs/browser';

// EmailJS configuration
const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

// Initialize EmailJS
if (EMAILJS_PUBLIC_KEY) {
  emailjs.init(EMAILJS_PUBLIC_KEY);
}

/**
 * Send email using EmailJS
 * @param {Object} templateParams - Email template parameters
 * @returns {Promise} - EmailJS send promise
 */
export const sendEmail = async (templateParams) => {
  // Check if EmailJS is properly configured
  if (!EMAILJS_SERVICE_ID || !EMAILJS_TEMPLATE_ID || !EMAILJS_PUBLIC_KEY) {
    throw new Error('EmailJS is not properly configured. Please check your environment variables.');
  }

  try {
    const result = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams,
      EMAILJS_PUBLIC_KEY
    );
    
    // Email sent successfully
    return result;
  } catch (error) {
    console.error('Failed to send email:', error);
    throw error;
  }
};

/**
 * Send API access request email
 * @param {Object} formData - Form data object
 * @returns {Promise} - EmailJS send promise
 */
export const sendAPIRequestEmail = async (formData) => {
  const templateParams = {
    to_name: 'CIVIONIKS Team',
    from_name: `${formData.firstName} ${formData.lastName}`,
    from_email: formData.email,
    company: formData.company,
    position: formData.position,
    message: formData.message,
    reply_to: formData.email,
    // Additional fields for better email formatting
    full_name: `${formData.firstName} ${formData.lastName}`,
    subject: `New API Access Request from ${formData.firstName} ${formData.lastName} at ${formData.company}`,
  };

  return await sendEmail(templateParams);
};

/**
 * Send confirmation email to the user
 * @param {Object} formData - Form data object
 * @returns {Promise} - EmailJS send promise
 */
export const sendConfirmationEmail = async (formData) => {
  const templateParams = {
    to_name: `${formData.firstName} ${formData.lastName}`,
    to_email: formData.email,
    company: formData.company,
    // This would typically use a different template for user confirmation
    template_id: process.env.REACT_APP_EMAILJS_CONFIRMATION_TEMPLATE_ID || EMAILJS_TEMPLATE_ID,
  };

  return await sendEmail(templateParams);
};

const emailService = {
  sendEmail,
  sendAPIRequestEmail,
  sendConfirmationEmail,
};

export default emailService;


